module.exports = __webpack_public_path__ + "static/media/social-1_logo-vimeo.07dd9ebe.svg";